<script setup lang="ts">
import { Mailing } from '@/@types/participant'
import Badge from '@/components/ui/badge/Badge.vue'
import { Ticket } from 'lucide-vue-next'

defineProps<{ mailing: Mailing }>()
</script>

<template>
    <aside class="font-inter flex h-fit flex-col justify-between gap-6 rounded-[10px] border-2 border-gray-100 bg-white p-6 text-sm">
        <div class="flex justify-center border-b-2 border-dashed pb-6">
            <span class="flex size-11 items-center justify-center rounded-full bg-cyan-50 text-cyan-700">
                <Ticket />
            </span>
        </div>
        <div>
            <span class="mr-2 font-semibold">{{ $t('Event') }}:</span>
            {{ mailing.workshop_description }}
        </div>
        <div>
            <span class="mr-2 font-semibold">{{ $t('Ticket type') }}:</span>
            {{ $t(mailing.ticket_category) }}
        </div>
        <div>
            <span class="mr-2 font-semibold">{{ $t('Email') }}:</span>
            <span class="break-all">{{ mailing.email }}</span>
        </div>
        <div>
            <span class="mr-2 font-semibold">{{ $t('Code') }}:</span>
            {{ mailing.code }}
        </div>
        <div>
            <span class="mr-2 font-semibold">{{ $t('Status') }}:</span>
            <Badge :variant="mailing.status">
                {{ $t(mailing.status) }}
            </Badge>
        </div>
    </aside>
</template>
